import { render, staticRenderFns } from "./ribbonCheck.vue?vue&type=template&id=4c5a77a8"
import script from "./ribbonCheck.vue?vue&type=script&lang=js"
export * from "./ribbonCheck.vue?vue&type=script&lang=js"
import style0 from "./ribbonCheck.vue?vue&type=style&index=0&id=4c5a77a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports